import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Pagination} from "page/util/Pagination";

export default function RagTraceMain() {
    const [pager, setPager] = useState();
    const [results, setResults] = useState([]);
    const [requestId, setRequestId] = useState("");
    const [chatRoomId, setChatRoomId] = useState("");
    const [buyerId, setBuyerId] = useState("");
    const [sellerId, setSellerId] = useState("");
    const [profileNo, setProfileNo] = useState("");
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [page, setPageState] = useState(1);

    const load = (nextPage = page) => {
        const params = {page: nextPage, size: 20};
        if (requestId) params.requestId = requestId;
        if (chatRoomId) params.chatRoomId = chatRoomId;
        if (buyerId) params.buyerId = buyerId;
        if (sellerId) params.sellerId = sellerId;
        if (profileNo) params.profileNo = profileNo;
        if (from) params.from = from;
        if (to) params.to = to;
        axios.get("/admin/v1/rag/traces", {params}).then(res => {
            setPager(res.data);
            setResults(res.data.content || []);
        });
    };

    useEffect(() => {
        load(page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const search = () => {
        setPageState(1);
        load(1);
    };

    const downloadFile = async (url, fallbackName) => {
        const response = await axios.get(url, {responseType: "blob"});
        const blob = new Blob([response.data], {type: response.headers["content-type"] || "application/octet-stream"});
        const cd = response.headers && (response.headers["content-disposition"] || response.headers["Content-Disposition"]);
        let filename = fallbackName;
        if (cd) {
            const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(cd);
            if (match) {
                filename = decodeURIComponent(match[1] || match[2]);
            }
        }

        const link = document.createElement("a");
        const objectUrl = window.URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(objectUrl);
    };

    const downloadCsv = () => downloadFile("/admin/v1/rag/traces/export-csv", "tta_rag_trace_log.csv");
    const downloadXlsx = () => downloadFile("/admin/v1/rag/traces/export-xlsx", "tta_rag_trace_log.xlsx");

    const deleteAll = async () => {
        if (!window.confirm("TTA 로그를 모두 삭제하시겠습니까?")) return;

        try {
            const response = await axios.delete("/admin/v1/tta/logs");
            window.alert(`${response.data.deletedCount || 0}건의 TTA 로그를 삭제했습니다.`);
            setPageState(1);
            load(1);
        } catch (error) {
            window.alert("TTA 로그 삭제에 실패했습니다.");
        }
    };

    const parseResults = (value) => {
        if (!value) return [];
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    };

    const groupResultsByDocument = (value) => {
        const parsed = parseResults(value);
        const grouped = new Map();

        parsed.forEach((result) => {
            const documentId = result?.documentId;
            if (documentId == null) return;

            const current = grouped.get(documentId);
            const score = Number(result.score ?? 0);
            const currentScore = current ? Number(current.score ?? 0) : -Infinity;

            if (!current || score > currentScore) {
                grouped.set(documentId, result);
            }
        });

        return Array.from(grouped.values()).sort((a, b) => Number(b.score ?? 0) - Number(a.score ?? 0));
    };

    const openUserDetail = (userId) => {
        if (!userId) return;
        window.open(`/page/users/detail?userId=${userId}`, '_blank', 'noopener,noreferrer');
    };

    const openChatDetail = (chatId) => {
        if (!chatId) return;
        window.open(`/page/chat/detail?id=${chatId}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">TTA &gt; 매칭 로그</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-flex justify-content-between align-items-start flex-wrap" style={{gap: 12}}>
                                        <div className="card-title mb-0">TTA &gt; 매칭 로그</div>
                                        <div className="d-flex flex-wrap" style={{gap: 8}}>
                                            <button className="btn btn-success btn-sm" onClick={downloadCsv}>CSV 다운로드</button>
                                            <button className="btn btn-primary btn-sm" onClick={downloadXlsx}>엑셀 다운로드</button>
                                            <button className="btn btn-danger btn-sm" onClick={deleteAll}>전체 삭제</button>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap mt-3" style={{gap: 8}}>
                                        <input className="form-control" style={{width: 180}} placeholder="requestId" value={requestId} onChange={e => setRequestId(e.target.value)} />
                                        <input className="form-control" style={{width: 120}} placeholder="매칭ID" value={chatRoomId} onChange={e => setChatRoomId(e.target.value)} />
                                        <input className="form-control" style={{width: 120}} placeholder="buyerId" value={buyerId} onChange={e => setBuyerId(e.target.value)} />
                                        <input className="form-control" style={{width: 120}} placeholder="sellerId" value={sellerId} onChange={e => setSellerId(e.target.value)} />
                                        <input className="form-control" style={{width: 100}} placeholder="profileNo" value={profileNo} onChange={e => setProfileNo(e.target.value)} />
                                        <input className="form-control" style={{width: 220}} placeholder="from (2026-06-17T00:00:00)" value={from} onChange={e => setFrom(e.target.value)} />
                                        <input className="form-control" style={{width: 220}} placeholder="to (2026-06-17T23:59:59)" value={to} onChange={e => setTo(e.target.value)} />
                                        <button className="btn btn-info btn-sm" style={{width: 90}} onClick={search}>검색</button>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0" style={{marginTop: 20, overflowX: "auto"}}>
                                    <table className="table table-hover" style={{textAlign: "center", tableLayout: "fixed", minWidth: 1900}}>
                                        <thead>
                                        <tr>
                                            <th style={{width: 180}}>문서 검색 실행 시각</th>
                                            <th style={{width: 180}}>로그 저장 시각</th>
                                            <th style={{width: 220}}>요청ID</th>
                                            <th style={{width: 120}}>매칭ID/채팅방ID</th>
                                            <th style={{width: 110}}>구매자ID</th>
                                            <th style={{width: 110}}>판매자ID</th>
                                            <th style={{width: 140}}>구매자 목표 직무</th>
                                            <th style={{width: 140}}>판매자 서비스 직무</th>
                                            <th style={{width: 110}}>서비스 유형</th>
                                            <th style={{width: 120}}>구매자 산업군</th>
                                            <th style={{width: 120}}>판매자 산업군</th>
                                            <th style={{width: 260}}>게시글 내용</th>
                                            <th style={{width: 280}}>검색 쿼리</th>
                                            <th style={{width: 220}}>필터</th>
                                            <th style={{width: 380}}>결과</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {results.map(item => (
                                            <tr key={item.requestId}>
                                                <td style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{item.retrievalExecutedAt || '-'}</td>
                                                <td style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{item.createdAt}</td>
                                                <td style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}} title={item.requestId}>{item.requestId}</td>
                                                <td>
                                                    {item.chatRoomId ? (
                                                        <button className="btn btn-link p-0 align-baseline" onClick={() => openChatDetail(item.chatRoomId)}>
                                                            {item.chatRoomId}
                                                        </button>
                                                    ) : '-'}
                                                </td>
                                                <td>
                                                    {item.buyerId ? (
                                                        <button className="btn btn-link p-0 align-baseline" onClick={() => openUserDetail(item.buyerId)}>
                                                            {item.buyerId}
                                                        </button>
                                                    ) : '-'}
                                                </td>
                                                <td>
                                                    {item.sellerId ? (
                                                        <button className="btn btn-link p-0 align-baseline" onClick={() => openUserDetail(item.sellerId)}>
                                                            {item.sellerId}
                                                        </button>
                                                    ) : '-'}
                                                </td>
                                                <td>{item.consumerTargetRole || '-'}</td>
                                                <td>{item.providerServiceRole || '-'}</td>
                                                <td>{item.serviceType || '-'}</td>
                                                <td>{item.consumerIndustry || '-'}</td>
                                                <td>{item.providerIndustry || '-'}</td>
                                                <td style={{whiteSpace: "pre-wrap", textAlign: "left", overflowWrap: "anywhere"}}>{item.postContent || '-'}</td>
                                                <td style={{whiteSpace: "pre-wrap", textAlign: "left", overflowWrap: "anywhere"}}>{item.queryText}</td>
                                                <td style={{whiteSpace: "pre-wrap", textAlign: "left", overflowWrap: "anywhere"}}>{item.filtersJson}</td>
                                                <td style={{whiteSpace: "pre-wrap", textAlign: "left", overflowWrap: "anywhere"}}>
                                                    {groupResultsByDocument(item.resultsJson).length === 0 ? (
                                                        item.resultsJson
                                                    ) : (
                                                        <div>
                                                            {groupResultsByDocument(item.resultsJson).map((result, index) => (
                                                                <div key={`${item.requestId}-${index}`}>
                                                                    {result.rank}. docId={result.documentId}, chunkId={result.chunkId}, docName={result.documentTitle || '-'}, score={result.score}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {pager && <Pagination pager={pager} setPage={setPageState} />}
                    </section>
                </div>
            </div>
        </div>
    );
}
